import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  dialogContainer: {
    zIndex: '9999 !important',
  },
  iconContainer: {
    textAlign: 'center',
    marginTop: theme.spacing(1),
  },
  icon: {
    fontSize: '3rem',
    color: 'red',
  },
}));
